import {caseServiceLogService} from '../../application'
import {
  CASE_SERVICE_LOG_FETCH_BY_CASE,
  CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED,
  CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS
} from "../mutations/available";

export function fetchLogByCase({commit, dispatch}, {caseId}) {
  commit(CASE_SERVICE_LOG_FETCH_BY_CASE, {caseId});

  return caseServiceLogService
    .getLogByCase({caseId})
    .then(response => {
      commit(CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS, {caseId: caseId, response: response})
    })
    .catch(e => {
      commit(CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED, {caseId: caseId});
      throw e
    })
}

export function addCaseService({dispatch}, request) {
  return caseServiceLogService.addCaseService(request)
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: request.caseId});
      return response
    })
}

export function deleteCaseService({dispatch}, {caseId, serviceId, comment}) {
  return caseServiceLogService.deleteCaseService({caseId, serviceId, comment})
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: caseId});
      return response
    })
}

export function addCaseServiceLog({commit, dispatch}, {caseId, serviceId, event, quantityChange, occurredAt, comment}) {
  return caseServiceLogService
    .addCaseServiceLog({
      caseId: caseId,
      serviceId: serviceId,
      event: event,
      quantityChange: quantityChange,
      occurredAt: occurredAt,
      comment: comment
    })
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: caseId});
      return response
    })
}

export function replaceCaseServiceLog({commit, dispatch}, {caseId, id, comment, serviceId, quantityChange}) {
  return caseServiceLogService
    .replaceCaseServiceLog({
      id: id,
      comment: comment,
      serviceId: serviceId,
      quantityChange: quantityChange
    })
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: caseId});
      return response
    })
}

export function deleteCaseServiceLog({commit, dispatch}, {caseId, id, comment}) {
  return caseServiceLogService
    .deleteCaseServiceLog({
      id: id,
      comment: comment
    })
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: caseId});
      return response
    })
}

export async function caseServiceLogUpdateCache({dispatch}, {caseId}) {
  dispatch('fetchLogByCase', {caseId});
  dispatch('updateAnalyticsForCase', {caseId});
  dispatch('invoiceUpdateInvoiceLogCandidatesByCase', {caseId})
}

export function caseServiceLogUpdateCaseServicesInfo({}, {caseId}) {
  return caseServiceLogService
    .updateCaseServicesInfo({caseId})
}

export function caseServiceLogUpdateAllCasesServicesInfo({}, {}) {
  return caseServiceLogService
    .updateAllCasesServicesInfo()
}

export function caseServiceLogRestartCaseToWork({dispatch}, request) {
  return caseServiceLogService
    .restartCaseToWork(request)
    .then(response => {
      dispatch('caseServiceLogUpdateCache', {caseId: request.caseId});
      return response
    })
}



// WEBPACK FOOTER //
// ./src/store/actions/case-service-log.js